import { render, staticRenderFns } from "./HeaderMenuCategories.vue?vue&type=template&id=8a3aa350&scoped=true&"
import script from "./HeaderMenuCategories.vue?vue&type=script&lang=js&"
export * from "./HeaderMenuCategories.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMenuCategories.vue?vue&type=style&index=0&id=8a3aa350&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3aa350",
  null
  
)

export default component.exports